/*
    Service objects used to add some functionality for UI objects
 */

//Hideable properties in dialogs
export const UIPHideable = {
    hide: function () {
        if (this._div)
            this._div.hidden = true;
    },

    show: function () {
        if (this._div)
            this._div.hidden = false;
    },

    isVisible: function () {
        if (this._div === undefined)
            return false
        return ! this._div.hidden;
    }
}
